module.exports = {"TXTCLI_Preview":{"id":"TXTCLI_Preview","defaultMessage":"Предпросмотр"},"TXTCLI_Report_3":{"id":"TXTCLI_Report_3","defaultMessage":"Отчет"}}